import newsIndex from '../data/news-index.json';

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  readTime: string;
  date: string;
  tags: string[];
  featured?: boolean;
  slug: string;
  contentPreview: string;
}

export const getAllArticles = (): Article[] => {
  return newsIndex as Article[];
};

export const searchArticles = (query: string, articles: Article[]): Article[] => {
  const lowerQuery = query.toLowerCase();
  return articles.filter(article => 
    article.title.toLowerCase().includes(lowerQuery) ||
    article.excerpt.toLowerCase().includes(lowerQuery) ||
    article.contentPreview.toLowerCase().includes(lowerQuery) ||
    article.tags.some(tag => tag.toLowerCase().includes(lowerQuery)) ||
    article.author.toLowerCase().includes(lowerQuery)
  );
};

export const getArticleBySlug = async (slug: string) => {
  try {
    // Dynamically import the article JSON file
    const articleData = await import(`../data/news/${slug}.json`);
    return {
      metadata: articleData.metadata,
      content: articleData.content,
      raw: articleData.raw
    };
  } catch (error) {
    console.error(`Failed to load article: ${slug}`, error);
    throw new Error('Article not found');
  }
};